<template>
  <div class="e-layout">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: "ClearLayout",
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/layouts/clear.vue